import { StatusChip, type StatusTone } from '@/components/ui/StatusChip';

import { statusWord, type LinkView } from './linkState';

/** The colour only repeats the word (PB2). */
function toneOf(view: LinkView): StatusTone {
  if (view.status !== 'PUBLISHED') return 'neutral';
  return view.hasUnpublishedChanges ? 'warning' : 'success';
}

/** The link's state beside the page title: Not set, "Saved, not published", Published, … (P2, P3, P38). */
export function LinkStatusChip({ view }: { view: LinkView }) {
  return (
    <StatusChip
      label={statusWord(view)}
      tone={toneOf(view)}
      testId={`arc-${view.kind}-status-value`}
    />
  );
}
